import { Card, Checkbox, Input, Modal, Popconfirm, Radio } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import tw from "tailwind-styled-components";
import { clearOvertime, getSingleOvertime, makeOverTimePayment, updateOvertimeStatus } from "../../redux/rtk/features/overtime/overtimeSlice";
import getUserFromToken from "../../utils/getUserFromToken";
import Loader from "../loader/loader";
import PageTitle from "../page-header/PageHeader";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";

const DetailOverTime = () => {
    const { id } = useParams("id");
    const approvedBy = getUserFromToken();
    const overtime = useSelector((state) => state.overtime.overtimeDetail);
    const dispatch = useDispatch();
    const [selectedStatus, setSelectedStatus] = useState(null);
    const [remarks, setRemarks] = useState("");
    const [modalVisible, setModalVisible] = useState(false);
    const [tempStatus, setTempStatus] = useState(null);

    useEffect(() => {
        dispatch(getSingleOvertime(id));
        return () => {
            dispatch(clearOvertime());
        };
    }, []);

    const handleStatusChange = (e) => {
        const isApproved = e.target.value === "approved";
        setTempStatus(isApproved ? 1 : 0);
        setModalVisible(true);
    };

    const handlePaymentStatusChange = (checked) => {
        const newStatus = checked ? "PAID" : "UNPAID";
    
        dispatch(
            makeOverTimePayment({
                id,
                values: { paymentStatus: newStatus },
            })
        )
            .unwrap()
            .then(() => {
                dispatch(getSingleOvertime(id));
                // toast.success(`Payment status updated to ${newStatus}`);
            })
            .catch((error) => {
                console.error("Error updating payment status:", error);
            });
    };

    const handleModalOk = async () => {
        try {
            const response = await dispatch(
                updateOvertimeStatus({
                    id,
                    values: {
                        approvedBy: approvedBy,
                        approve: tempStatus,
                        remark: remarks,
                        rewardType: overtime[0]?.overtimeReward === false ? false : true,
                    },
                })
            );

            if (response.payload.message === "success") {
                toast.success(`Overtime ${tempStatus === 1 ? "approved" : "rejected"} successfully`);
                dispatch(getSingleOvertime(id));
                setSelectedStatus(tempStatus);
                setModalVisible(false);
            } else {
                throw new Error("Error updating overtime");
            }
        } catch (error) {
            toast.error(`Failed to ${tempStatus === 1 ? "approve" : "reject"} overtime: ${error.message}`);
        }
    };

    const handleModalCancel = () => {
        setModalVisible(false);
        setRemarks("");
        setTempStatus(null);
    };

    const formatOvertimeLength = (length) => {
        const hours = Math.floor(length);
        const minutes = Math.round((length - hours) * 60);
        return `${hours}h ${minutes}m`;
    };

    return (
        <div>
            <PageTitle title="Back" />
            <Card className="mt-4">
                <div className="text-center mb-4">
                    <h2 className="text-2xl font-semibold text-gray-600">Overtime Status</h2>
                </div>
                {overtime ? (
                    <div className="flex justify-center">
                        <ul className="list-inside list-none border-2 border-inherit rounded px-5 py-5">
                            <ListItem>
                                Name:
                                <TextInside>
                                    {overtime[0]?.user?.firstName && overtime[0]?.user?.lastName
                                        ? `${overtime[0].user?.firstName} ${overtime[0].user?.lastName}`.toUpperCase()
                                        : "N/A"}
                                </TextInside>
                            </ListItem>
                            <ListItem>
                                Overtime Start:
                                <TextInside>
                                    {dayjs(overtime[0].overtimeStart).utc().format("DD-MM-YYYY, h:mm A")}
                                </TextInside>
                            </ListItem>
                            <ListItem>
                                Overtime End:
                                <TextInside>
                                    {dayjs(overtime[0].overtimeEnd).utc().format("DD-MM-YYYY, h:mm A")}
                                </TextInside>
                            </ListItem>
                            <ListItem>
                                Overtime Reward:
                                <TextInside>
                                    {overtime[0].overtimeReward === false ? "Toil" : "Payable"}
                                </TextInside>
                            </ListItem>
                            <ListItem>
                                Pay Rate:
                                <TextInside>
                                    {overtime[0]?.payRate ? `${overtime[0].payRate.toFixed(2)}` : "N/A"}
                                </TextInside>
                            </ListItem>

                            <ListItem>
                                Overtime Length:
                                <TextInside>
                                    {overtime[0]?.overtimeLength
                                        ? formatOvertimeLength(overtime[0]?.overtimeLength)
                                        : "No overtime length"}
                                </TextInside>
                            </ListItem>
                            <ListItem>
                                Note:
                                <TextInside>{overtime[0].note || "No Note"}</TextInside>
                            </ListItem>
                            <ListItem>
                                Status:
                                {/* <TextInside>{overtime[0].approve === 1? "Approved" :overtime[0].approve === 0? "Rejected" : "Pending"}</TextInside> */}
                                <TextInside className={
                                    overtime[0].approve === 1 ? "text-green-500" :
                                        overtime[0].approve === 0 ? "text-red-500" :
                                            "text-yellow-500"
                                }>
                                    {overtime[0].approve === 1 ? "Approved" : overtime[0].approve === 0 ? "Rejected" : "Pending"}
                                </TextInside>

                            </ListItem>
                            <ListItem>
                                Payment Status:{" "}
                                <TextInside>
                                    <UserPrivateComponent permission={"readAll-role"}>
                                        <Popconfirm
                                            title={`Are you sure you want to mark this overtime as ${
                                                overtime[0].paymentStatus === "PAID" ? "UNPAID" : "PAID"
                                            }?`}
                                            onConfirm={() =>
                                                handlePaymentStatusChange(overtime[0].paymentStatus !== "PAID")
                                            }
                                            okText="Yes"
                                            cancelText="No"
                                        >
                                            <Checkbox checked={overtime[0].paymentStatus === "PAID"}>
                                                {overtime[0].paymentStatus === "PAID" ? (
                                                    <span className="text-green-500">PAID</span>
                                                ) : (
                                                    <span className="text-red-500">UNPAID</span>
                                                )}
                                            </Checkbox>
                                        </Popconfirm>
                                    </UserPrivateComponent>
                                </TextInside>
                            </ListItem>
                            <div className="mt-4 flex justify-center">
                                {overtime[0].approve === null ? (
                                    <Radio.Group
                                        onChange={handleStatusChange}
                                        value={selectedStatus === 1 ? "approved" : selectedStatus === 0 ? "rejected" : null}
                                    >
                                        <Radio.Button
                                            value="approved"
                                            className="mr-4 bg-green-500 text-white hover:bg-green-600 focus:ring-green-500"
                                        >
                                            Approve
                                        </Radio.Button>
                                        <Radio.Button
                                            value="rejected"
                                            className="bg-red-500 text-white hover:bg-red-600 focus:ring-red-500"
                                        >
                                            Reject
                                        </Radio.Button>
                                    </Radio.Group>
                                ) : null}
                            </div>
                        </ul>
                    </div>
                ) : (
                    <Loader />
                )}
            </Card>

            <Modal
                title={`Confirm ${tempStatus === 1 ? "Approval" : "Rejection"}`}
                open={modalVisible}
                onOk={handleModalOk}
                onCancel={handleModalCancel}
                okText="Submit"
                cancelText="Cancel"
            >
                <p>Are you sure you want to {tempStatus === 1 ? "approve" : "reject"} this overtime?</p>
                <Input.TextArea
                    placeholder="Enter remarks (optional)"
                    rows={4}
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    className="mt-4"
                />
            </Modal>
        </div>
    );
};

const ListItem = tw.li`
text-sm
text-gray-600
font-semibold
py-2
px-4
bg-gray-100
mb-1.5
rounded
w-96
flex
justify-start
`;

const TextInside = tw.p`
ml-2
text-sm
text-gray-900
`;

export default DetailOverTime;